import { Modal, ModalActions, ModalContent, ModalContentText, ModalTitle } from '@carrier-io/air-react';
import Button from '@carrier-io/air-react/Button';
import styles from '../../styles/Popup.module.css';

export type ConfirmPopupProps = {
  confirmTitle?: string;
  textContent?: string;
  confirmButtonText?: string;
  showCancelButton?: boolean;
  disableConfirmButton?: boolean;
  opened: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmPopup = ({
  confirmTitle = 'Are you sure you want to cancel?',
  textContent = '',
  opened,
  showCancelButton = true,
  confirmButtonText = 'Yes',
  disableConfirmButton = false,
  onCancel,
  onConfirm,
}: ConfirmPopupProps) => {
  return (
    <Modal maxWidth="sm" open={opened} scroll="paper">
      <>
        <ModalTitle data-testid="confirmation-title" clearable onClose={onCancel}>
          {confirmTitle}
        </ModalTitle>
        {textContent && (
          <ModalContent>
            <ModalContentText data-testid="confirmation-content">{textContent}</ModalContentText>
          </ModalContent>
        )}
        <ModalActions className={styles.confirmModalActions}>
          {showCancelButton && (
            <Button data-testid="confirmation-no" color="secondary" onClick={onCancel} variant="text">
              No
            </Button>
          )}
          <Button data-testid="confirmation-yes" disabled={disableConfirmButton} onClick={onConfirm} variant="outlined">
            {confirmButtonText}
          </Button>
        </ModalActions>
      </>
    </Modal>
  );
};
